
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_10631_29978)","stroke":"#141B34","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M14.212 4.761l-.33-.571c-.248-.432-.373-.648-.584-.734-.212-.086-.451-.018-.93.118l-.814.229c-.306.07-.626.03-.905-.113l-.225-.13a1.332 1.332 0 01-.526-.645l-.222-.665c-.147-.44-.22-.66-.394-.786-.174-.125-.406-.125-.869-.125H7.67c-.463 0-.694 0-.868.125-.175.126-.248.346-.394.786l-.223.665a1.333 1.333 0 01-.525.645l-.225.13c-.28.143-.6.183-.906.113l-.813-.23c-.479-.135-.718-.203-.93-.117-.212.086-.336.302-.585.734l-.33.57c-.232.406-.35.608-.326.824.022.215.178.389.49.736l.688.769c.168.212.287.583.287.916 0 .334-.119.704-.287.917l-.687.768c-.313.348-.469.521-.491.737-.023.215.094.418.327.822l.329.571c.249.432.373.648.585.735.212.086.451.018.93-.118l.813-.23c.306-.07.627-.03.906.114l.225.13c.24.152.423.378.525.644l.223.665c.146.44.22.66.394.786.174.126.405.126.868.126h.743c.463 0 .695 0 .869-.126.174-.126.247-.346.394-.786l.222-.665c.102-.266.286-.492.526-.645l.224-.13c.28-.143.6-.183.906-.112l.814.229c.479.136.718.204.93.118.211-.087.336-.303.585-.735h0l.329-.57c.233-.405.35-.608.327-.823-.023-.216-.179-.39-.491-.737l-.687-.768c-.168-.213-.288-.583-.288-.917 0-.333.12-.704.288-.916l.687-.769c.312-.347.468-.52.491-.736.023-.216-.094-.418-.327-.823z","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M10.346 8A2.333 2.333 0 115.68 8a2.333 2.333 0 014.666 0z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_10631_29978"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    